import styled from '@emotion/styled'
import { DateRange } from 'react-date-range'

const SELECTED_DATE_COLOR = '#fff'
const END_DATE = '#3c4d62'
const StyledWrapper = styled.div`
  position: relative;
`
const StyledRange = styled(DateRange)`
  padding: 10px;
  direction: ltr;
  border-right: 1px solid #dbdfea;
  box-shadow: none;
  width: 270px;
  color: #526484;
  background: #fff;
  .rdrMonthAndYearWrapper,
  .rdrWeekDays {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 800;
    font-size: 12px;
  }
  .rdrWeekDay {
    width: 34px;
    height: 30px;
    padding: 4px;
  }
  .rdrDay {
    position: relative;
  }
  .rdrDays {
    display: flex;
    flex-wrap: wrap;
    button {
      outline: none;
      background: #fff;
      border: none;
      padding: 0;
      width: 35px;
      height: 30px;
      margin: 0;
      span:hover {
        background: #ebeef2;
        cursor: pointer;
        line-height: 22px;
      }
    }
    .rdrDayNumber {
      padding: 4px;
      display: block;
      text-align: center;
      width: 35px;
      border-radius: 4px;
      height: 30px;
      color: #526484;
      position: absolute;
      left: 0;
      top: 0;
      line-height: 22px;
    }
    .rdrDayPassive .rdrDayNumber {
      color: #dbdfea;
    }
  }
  .rdrNextPrevButton {
    display: block;
    width: 24px;
    height: 24px;
    margin: 0 0.833em;
    padding: 0;
    border: 0;
    border-radius: 4px;
    background: #fff;
    &:hover {
      background: #ebeef2;
      cursor: pointer;
    }
    i {
      display: block;
      width: 0;
      height: 0;
      padding: 0;
      text-align: center;
      border-style: solid;
      margin: auto;
      transform: translate(-3px, 0px);
    }
  }

  .rdrPprevButton {
    i {
      border-width: 4px 6px 4px 4px;
      border-color: transparent rgb(52, 73, 94) transparent transparent;
      transform: translate(-3px, 0px);
    }
  }

  .rdrNextButton {
    i {
      margin: 0 0 0 7px;
      border-width: 4px 4px 4px 6px;
      border-color: transparent transparent transparent rgb(52, 73, 94);
      transform: translate(3px, 0px);
    }
  }
  .rdrMonthAndYearPickers {
    display: flex;
    font-weight: 600;
    select {
      appearance: none;
      -webkit-appearance: none;
      border: 0;
      background: transparent;
      padding: 10px 30px 10px 10px;
      border-radius: 4px;
      outline: 0;
      color: #3e484f;
      background-position: right 8px center;
      cursor: pointer;
      text-align: center;
    }
  }
  .rdrMonthPicker {
    option {
      -webkit-appearance: none;
      background: #fff;
      cursor: pointer;
    }
  }

  .rdrSelected,
  .rdrInRange,
  .rdrStartEdge,
  .rdrEndEdge {
    width: 35px;
    height: 30px;
    background: #dbdfea;
    position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    bottom: 5px;
  }

  .rdrStartEdge {
    border-radius: 4px;
    background: ${({ startDateBackground }) => {
      return startDateBackground || 'var(--ow-color-primary-600)'
    }};
  }
  .rdrEndEdge {
    border-radius: 4px;
    background: ${({ endDateBackground }) => {
      return endDateBackground || END_DATE
    }};
  }

  .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span {
    color: ${({ selectedDateColor }) => {
      return selectedDateColor || SELECTED_DATE_COLOR
    }};
  }
  .rdrDateDisplay {
    display: none;
  }
`

const StyledTimeSelect = styled('div')`
  flex-direction: column;
  padding: 10px 0;
  text-align: cener;
  width: 70px;
  height: 264px;
  .timeResult {
    height: 34px;
    line-height: 34px;
    border-bottom: 1px solid #dbdfea;
    padding: 0 10px;
    text-align: center;
  }
  .list {
    flex: 1;
    display: flex;
    flex-direction: row;
    overflow: scroll;
    padding: 4px 0;
    height: 230px;
    > div {
      flex: 1;
      text-align: center;
      overflow: scroll;
    }
  }
`

const StyleRangeWrapper = styled('div')`
  position: absolute;
  top: 40px;
  left: 0;
  z-index: 999;
  padding: 0;
  border-radius: 4px;
  direction: ltr;
  border: 1px solid #dbdfea;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  color: #526484;
  background: #fff;
`
const StyledButton = styled('div')`
  padding: 8px;
  text-align: right;
  .mantine-UnstyledButton-root {
    width: 80px;
    height: 32px;
    line-height: 32px;
  }
  button {
    background: var(--ow-color-primary-600);
  }
`
export {
  StyledWrapper,
  StyledRange,
  StyleRangeWrapper,
  StyledTimeSelect,
  StyledButton,
}
